<template>
  <van-overlay :show="show">
    <div class="wrapper" @click.stop>
      <div class="block">
        <van-circle v-model="currentRate" :speed="0.01" :text="text" size="140" :color="gradientColor" :stroke-width="100" />
      </div>
    </div>
  </van-overlay>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    percent: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: '上传'
    },
    gradientColor: {
      type: Object,
      default() {
        return {
          '0%': '#3fecff',
          '100%': '#6149f6'
        }
      }
    }
  },

  data() {
    return {
    }
  },

  computed: {
    // 保存两位小数
    currentRate: {
      get() {
        return Math.floor(this.percent * 100) / 100
      },
      set(value) {
        this.$emit('changePercent', this.percent)
      }
    },
    text() {
      if (this.percent === 0) return '开始' + this.name
      else if (this.percent === 100) return this.name + '成功'
      else return `${(this.percent).toFixed(2)}% ${this.name}中...`
    }
  }
}
</script>
<style lang="scss" scoped>
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 200px;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/.van-circle__text{
    color: #fff!important;
  }
</style>
